const RESET_DELAYS = [100, 300]

export function resetViewportScroll ({ win = typeof window === 'undefined' ? null : window } = {}) {
  if (!win || typeof win.scrollTo !== 'function') return

  const scrollToTop = () => win.scrollTo(0, 0)
  scrollToTop()

  if (typeof win.requestAnimationFrame === 'function') {
    win.requestAnimationFrame(scrollToTop)
  }
  if (typeof win.setTimeout === 'function') {
    RESET_DELAYS.forEach(delay => win.setTimeout(scrollToTop, delay))
  }
}

export function releaseActiveInput ({
  doc = typeof document === 'undefined' ? null : document,
  win = typeof window === 'undefined' ? null : window
} = {}) {
  const activeElement = doc?.activeElement
  if (activeElement && activeElement !== doc.body && typeof activeElement.blur === 'function') {
    activeElement.blur()
  }
  resetViewportScroll({ win })
}
